import type { Currency } from "@/types";

const USD_HINTS = /^(usd|us\$|\$|dollar)s?$/i;
const ILS_HINTS = /^(ils|nis|₪|sheqel|shekel|ש"ח|שח)s?$/i;
const EUR_HINTS = /^(eur|€|euro)s?$/i;
export const SUPPORTED_APP_CURRENCIES = ["USD", "ILS", "EUR"] as const;
export const DEFAULT_APP_CURRENCY: Currency = "USD";

/** Normalize spreadsheet / bank text to supported ISO codes; unknown → USD */
export function normalizeCurrency(raw: string | undefined | null): Currency {
  if (raw == null) return DEFAULT_APP_CURRENCY;
  const s = String(raw).trim();
  if (!s) return DEFAULT_APP_CURRENCY;
  const compact = s.replace(/\s+/g, "");
  if (USD_HINTS.test(compact) || compact === "US") return "USD";
  if (ILS_HINTS.test(compact) || compact === "IL" || compact === "ISR")
    return "ILS";
  if (EUR_HINTS.test(compact) || compact === "EU") return "EUR";
  return DEFAULT_APP_CURRENCY;
}

export function isValidCurrencyParam(v: string | null): v is Currency {
  return !!v && SUPPORTED_APP_CURRENCIES.includes(v as Currency);
}

export function coerceSupportedCurrency(
  v: string | null | undefined,
): Currency {
  return v && isValidCurrencyParam(v) ? v : DEFAULT_APP_CURRENCY;
}
